// ═══════════════════════════════════════════════════════
// Schoolizy — ParentContext
// Charge les enfants du parent connecté et expose
// les studentIds pour filtrer toutes les données
// ═══════════════════════════════════════════════════════
import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api/client';
import { useAuth } from './AuthContext';

export const ParentContext = createContext(null);

export function ParentProvider({ children }) {
  const { user } = useAuth();
  const [children_, setChildren] = useState([]); // élèves liés à ce parent
  const [loading, setLoading]    = useState(false);
  const isParent = (user?.roles || []).includes('PARENT');

  useEffect(() => {
    // Ne charger que si le rôle est PARENT — stopper immédiatement sinon
    if (!isParent || !user?.id) { setLoading(false); return; }
    let cancelled = false;
    setLoading(true);
    api.get('/parents/my-children').then((data) => {
      if (cancelled) return;
      const students = (data || []).map((sp) => sp.student || sp).filter(Boolean);
      setChildren(students);
      setLoading(false);
    }).catch(() => {
      if (cancelled) return;
      setChildren([]);
      setLoading(false);
      // Ne pas retry — la route n'existe peut-être pas encore
    });
    return () => { cancelled = true; };
  // Dépendances stables — ne pas inclure isParent pour éviter boucle
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  const studentIds = children_.map((s) => s.id || s.studentId);

  return (
    <ParentContext.Provider value={{ children: children_, studentIds, loading, isParent }}>
      {children}
    </ParentContext.Provider>
  );
}

export function useParent() {
  const ctx = useContext(ParentContext);
  if (!ctx) return { children: [], studentIds: [], loading: false, isParent: false };
  return ctx;
}
